// Base
import Image, { StaticImageData } from 'next/image'

// Redux
import { useAppSelector } from '@redux/hooks'

// Components
import { Box } from 'yard-utilities/components'
import TextReviewCard from '@components/v25/es/ft1/cards/review/TextReviewCard'

// Styles
import styles from './CustomerReviewCard.module.sass'

interface CustomerReviewCardProps {
  image: string | StaticImageData
  review: {
    name: string
    flag?: string
    country?: string
    quote: string
    message: string
    price?: number
    messageEnd?: string
    memberSince: number
  }
}

const CustomerReviewCard = ({ image, review }: CustomerReviewCardProps) => {
  const { exchangeRate, currency } = useAppSelector((state) => state.visitor)

  return (
    <div>
      <Box
        borderRadius={{ sm: [16] }}
        overflow="hidden"
        spacing={{ sm: 24 }}
        className={styles.card}
      >
        <Image
          src={image}
          fill
          sizes="800px"
          alt={`Image of ${review.name}`}
          className={styles.image}
        />
      </Box>
      <TextReviewCard
        name={
          <>
            {review.name}
            {review.country && `, ${review.country}`}{' '}
            {review.flag && (
              <Image
                src={`/images/v25/icons/es-ft1/${review.flag}.png`}
                width={16}
                height={17}
                alt={`flag of ${review.country}`}
              />
            )}
          </>
        }
        message={review.message}
        price={review.price}
        messageEnd={review.messageEnd}
        quote={review.quote}
        memberSince={review.memberSince}
      />
    </div>
  )
}

export default CustomerReviewCard
